import { Link } from '@inertiajs/react'
import { BackofficeLayout } from '@/components/layout/BackofficeLayout'
import { Button } from '@/components/ui/button'
import { CheckCircle2, ArrowLeft } from 'lucide-react'

type Filing = {
  id: string
  type_name: string
  business_name: string
}

type Record = {
  id: string
  period_start_date: string
  period_end_date: string
}

type Completion = {
  id: string
  created_at: string
} | null

type Props = {
  filing: Filing
  record: Record
  completion: Completion
}

export default function BackofficeComplianceFilingsRecordsCompletionsShow({ filing, record, completion }: Props) {
  return (
    <BackofficeLayout
      title="Completion"
      breadcrumbs={[
        { label: 'Backoffice', href: '/backoffice/dashboard' },
        { label: 'Compliance Filings', href: '/backoffice/compliance_filings' },
        { label: filing.type_name, href: `/backoffice/compliance_filings/${filing.id}` },
        { label: `${record.period_start_date} - ${record.period_end_date}`, href: `/backoffice/compliance_filings/${filing.id}/records/${record.id}` },
        { label: 'Completion' },
      ]}
    >
      <div className="space-y-6">
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight">Completion</h1>
          <p className="text-sm text-muted-foreground">{filing.business_name} · {record.period_start_date} — {record.period_end_date}</p>
        </div>

        <section className="border rounded-lg">
          <div className="px-4 py-3 border-b">
            <h2 className="text-sm font-medium text-foreground">Filing Period Status</h2>
          </div>
          <div className="px-4 py-3">
            {completion ? (
              <div className="space-y-1.5">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-600" />
                  <span className="text-sm font-medium text-green-600">Completed</span>
                </div>
                <div className="flex justify-between text-sm mt-2">
                  <span className="text-muted-foreground">Completed on</span>
                  <span>{new Date(completion.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            ) : (
              <p className="text-sm text-muted-foreground text-center py-4">Not yet completed</p>
            )}
          </div>
        </section>

        <div>
          <Button variant="outline" asChild>
            <Link href={`/backoffice/compliance_filings/${filing.id}/records/${record.id}`}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Record
            </Link>
          </Button>
        </div>
      </div>
    </BackofficeLayout>
  )
}
